const env = {
  apiUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api/v1',
  isDevelopment: import.meta.env.DEV || false,
  /**
   * Lets inspection photos come out of the gallery instead of the camera.
   *
   * Off unless a build explicitly turns it on, so production enforces live
   * capture and no deploy can drift into permissiveness by forgetting a flag.
   * Set VITE_ALLOW_GALLERY_PHOTOS=true locally to test on a laptop with no
   * camera.
   */
  allowGalleryPhotos: import.meta.env.VITE_ALLOW_GALLERY_PHOTOS === 'true',
  /**
   * The dispatch dashboard, which every dashboard link opens: Go to
   * dashboard, Operations, billing. Each deploy sets its own, and a Vercel
   * build without one fails (vite.config.ts). It fell back to production,
   * so a local or staging app sent every dashboard link to the live one;
   * locally it is the dashboard's own dev server.
   */
  dashboardUrl:
    import.meta.env.VITE_DASHBOARD_URL ||
    (import.meta.env.DEV ? 'http://localhost:5173' : ''),
  appStore: {
    ios:
      import.meta.env.VITE_APP_STORE_IOS_LINK ||
      'https://apps.apple.com/us/app/relay-driver/id1234567890',
    android:
      import.meta.env.VITE_APP_STORE_ANDROID_LINK ||
      'https://play.google.com/store/apps/details?id=com.relaytow.driver',
  },
};

export default env;
